// extracted by mini-css-extract-plugin
module.exports = {"blob":"Blob-module--blob--F_Ob3"};